import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

interface MockGetPMSDistributionsPathParams {
  alphaId: string
}

export const mockGetPMSDistributions =
  http.get<MockGetPMSDistributionsPathParams>(
    '/my-business/api/agency/v1/*/:alphaId/pms/distributions',
    () => {
      const distributions = Array.from({ length: 10 }).map((_, i) => ({
        pmsId: (i + 1).toString(),
        code: faker.lorem.word(),
      }))

      return HttpResponse.json({ pmsDistChannelId: { '1': distributions } })
    },
  )
